import styles from './index.module.sass';
import PlusSvg from '@/modules/mixing/images/plus.svg';
import DeleteSvg from '@/modules/mixing/images/delete.svg';
import { SelectBunker } from '../select';
import { singleSectionItem } from '../../hooks';

export const SingleOption = ({
  isLast,
  removeSingleSectionItem,
  num,
  addSingleSectionItem,
  setSingleSectionItemValue,
  options,
  item,
}: ISingleOption) => {
  return (
    <div className={styles.single}>
      <div className={styles.selector__single}>
        {isLast ? (
          <img src={PlusSvg} alt="icon" onClick={addSingleSectionItem} />
        ) : (
          <img
            src={DeleteSvg}
            alt="icon"
            onClick={() => removeSingleSectionItem(num)}
          />
        )}
      </div>
      <div className={styles.select__form}>
        <SelectBunker
          bunker={item}
          onChange={(item: any) => {
            setSingleSectionItemValue({
              label: item.label,
              id: item.value,
              itemIdx: num,
            });
          }}
          options={options.filter((item: any) => item.type === 2)}
        />
      </div>
    </div>
  );
};

interface ISingleOption {
  isLast: boolean;
  removeSingleSectionItem: (idx: number) => void;
  num: number;
  addSingleSectionItem: () => void;
  setSingleSectionItemValue: (args: {
    label: string;
    id: number;
    itemIdx: number;
  }) => void;
  item: singleSectionItem;
  options: any;
}
